import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConstructionSign = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31 11H9C8.73478 11 8.48043 11.1054 8.29289 11.2929C8.10536 11.4804 8 11.7348 8 12V21C8 21.2652 8.10536 21.5196 8.29289 21.7071C8.48043 21.8946 8.73478 22 9 22H31C31.2652 22 31.5196 21.8946 31.7071 21.7071C31.8946 21.5196 32 21.2652 32 21V12C32 11.7348 31.8946 11.4804 31.7071 11.2929C31.5196 11.1054 31.2652 11 31 11ZM30 18L25 13H30V18ZM27 20H20L13 13H20L27 20ZM10 15L15 20H10V15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 9H26V11H28V9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 9H12V11H14V9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 23H12V29.018H9V31H17V29.018H14V23Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 29.018V23H26V29.018H23V31H31V29.018H28Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgConstructionSign);
export default ForwardRef;
